import type { SVGProps } from "react";
export default function SvgMoveDiagonal(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-move-diagonal-icon lucide-move-diagonal"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M11 19H5v-6" />
			<path d="M13 5h6v6" />
			<path d="M19 5 5 19" />
		</svg>
	);
}
